import { render } from "./AboutMeComponent.vue?vue&type=template&id=51bc7224"
import script from "./AboutMeComponent.vue?vue&type=script&lang=js"
export * from "./AboutMeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__